<template>
  <div class="c--shared_breadcrumb new-container mx-auto">
    <div :class="['partner-with-us-breadcrumb mt-40 mb-20', { 'display-none': deviceType.isMobile }]">
      <div
        v-for="(breadcrumb, index) in breadcrumbs"
        :key="`partner-with-us-breadcrumb-${index}`"
        class="partner-with-us-breadcrumb-item display-flex align-items-center"
      >
        <template v-if="breadcrumb.link && index !== breadcrumbs.length - 1">
          <nuxt-link :to="localePath(breadcrumb.link)" :class="['typo-p-small mb-0']">
            {{ breadcrumb.title }}
          </nuxt-link>
        </template>
        <template v-else>
          <p :class="['typo-p-small mb-0']">
            {{ breadcrumb.title }}
          </p>
        </template>

        <span
          v-if="index !== breadcrumbs.length - 1"
          class="airalo-icon-arrow-right tw-text-3 tw-text-zinc-500 airalo-icon-wrapper"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'breadcrumb',

    props: ['breadcrumbs'],

    computed: {
      deviceType() {
        return this.$store.getters.get_device_types
      },
    },
  }
</script>

<style lang="scss" scoped>
  .partner-with-us-breadcrumb {
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    justify-content: flex-start;

    .partner-with-us-breadcrumb-item {
      p,
      a {
        color: #8a8a8a;
      }

      &:last-of-type p {
        color: #4a4a4a;
      }

      .airalo-icon-wrapper {
        margin: 0 8px;

        [dir='rtl'] & {
          transform: rotateY(180deg);
        }
      }
    }
  }
</style>
